import React, { useState, useEffect } from 'react';
import API from '../api';
import { SellerSpinner } from '../components/skeleton';
import '../styles/SellerCommon.css';
import './ShippingRatesPage.css';

const ShippingRatesPage = () => {
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showWizard, setShowWizard] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    countries: {
      apply_to_all: false,
      specific_countries: []
    },
    products: {
      apply_to_all: true,
      brands: {
        include: [],
        exclude: []
      },
      product_types: {
        include: [],
        exclude: []
      },
      marketplace_vendors: {
        include: [],
        exclude: []
      }
    },
    processing_time: {
      min_days: 1,
      max_days: 2
    },
    transit_time: {
      min_days: 1,
      max_days: 2
    },
    shipping_cost: {
      type: 'fixed',
      fixed_amount: 0,
      price_rules: [],
      weight_rules: [],
      item_count_rules: [],
      free_shipping_threshold: null
    }
  });
  const [message, setMessage] = useState('');
  const [wizardMessage, setWizardMessage] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [editRateId, setEditRateId] = useState(null);

  // Stati per i tag input
  const [tagInputs, setTagInputs] = useState({
    brandsInclude: '',
    brandsExclude: '',
    productTypesInclude: '',
    productTypesExclude: '',
    marketplaceVendorsInclude: '',
    marketplaceVendorsExclude: ''
  });

  // Dati per i dropdown - Paesi raggruppati per regioni
  const regions = [
    { id: 'EU', name: 'Europa' },
    { id: 'NA', name: 'Nord America' },
    { id: 'SA', name: 'Sud America' },
    { id: 'ASIA', name: 'Asia' },
    { id: 'AFRICA', name: 'Africa' },
    { id: 'OCEANIA', name: 'Oceania' }
  ];

  const countries = [
    // Europa
    { code: 'IT', name: 'Italia', region: 'EU' },
    { code: 'FR', name: 'Francia', region: 'EU' },
    { code: 'DE', name: 'Germania', region: 'EU' },
    { code: 'ES', name: 'Spagna', region: 'EU' },
    { code: 'GB', name: 'Regno Unito', region: 'EU' },
    { code: 'NL', name: 'Paesi Bassi', region: 'EU' },
    { code: 'BE', name: 'Belgio', region: 'EU' },
    { code: 'AT', name: 'Austria', region: 'EU' },
    { code: 'CH', name: 'Svizzera', region: 'EU' },
    { code: 'SE', name: 'Svezia', region: 'EU' },
    { code: 'NO', name: 'Norvegia', region: 'EU' },
    { code: 'DK', name: 'Danimarca', region: 'EU' },
    { code: 'FI', name: 'Finlandia', region: 'EU' },
    { code: 'PL', name: 'Polonia', region: 'EU' },
    { code: 'CZ', name: 'Repubblica Ceca', region: 'EU' },
    { code: 'HU', name: 'Ungheria', region: 'EU' },
    { code: 'RO', name: 'Romania', region: 'EU' },
    { code: 'BG', name: 'Bulgaria', region: 'EU' },
    { code: 'HR', name: 'Croazia', region: 'EU' },
    { code: 'SI', name: 'Slovenia', region: 'EU' },
    { code: 'SK', name: 'Slovacchia', region: 'EU' },
    { code: 'LT', name: 'Lituania', region: 'EU' },
    { code: 'LV', name: 'Lettonia', region: 'EU' },
    { code: 'EE', name: 'Estonia', region: 'EU' },
    { code: 'IE', name: 'Irlanda', region: 'EU' },
    { code: 'PT', name: 'Portogallo', region: 'EU' },
    { code: 'GR', name: 'Grecia', region: 'EU' },
    { code: 'MT', name: 'Malta', region: 'EU' },
    { code: 'CY', name: 'Cipro', region: 'EU' },
    { code: 'LU', name: 'Lussemburgo', region: 'EU' },
    
    // Nord America
    { code: 'US', name: 'Stati Uniti', region: 'NA' },
    { code: 'CA', name: 'Canada', region: 'NA' },
    { code: 'MX', name: 'Messico', region: 'NA' },
    
    // Sud America
    { code: 'BR', name: 'Brasile', region: 'SA' },
    { code: 'AR', name: 'Argentina', region: 'SA' },
    { code: 'CL', name: 'Cile', region: 'SA' },
    { code: 'CO', name: 'Colombia', region: 'SA' },
    { code: 'PE', name: 'Perù', region: 'SA' },
    { code: 'VE', name: 'Venezuela', region: 'SA' },
    { code: 'EC', name: 'Ecuador', region: 'SA' },
    { code: 'BO', name: 'Bolivia', region: 'SA' },
    { code: 'PY', name: 'Paraguay', region: 'SA' },
    { code: 'UY', name: 'Uruguay', region: 'SA' },
    { code: 'GY', name: 'Guyana', region: 'SA' },
    { code: 'SR', name: 'Suriname', region: 'SA' },
    { code: 'FK', name: 'Isole Falkland', region: 'SA' },
    
    // Asia
    { code: 'CN', name: 'Cina', region: 'ASIA' },
    { code: 'JP', name: 'Giappone', region: 'ASIA' },
    { code: 'KR', name: 'Corea del Sud', region: 'ASIA' },
    { code: 'IN', name: 'India', region: 'ASIA' },
    { code: 'TH', name: 'Thailandia', region: 'ASIA' },
    { code: 'VN', name: 'Vietnam', region: 'ASIA' },
    { code: 'MY', name: 'Malesia', region: 'ASIA' },
    { code: 'SG', name: 'Singapore', region: 'ASIA' },
    { code: 'ID', name: 'Indonesia', region: 'ASIA' },
    { code: 'PH', name: 'Filippine', region: 'ASIA' },
    { code: 'TW', name: 'Taiwan', region: 'ASIA' },
    { code: 'HK', name: 'Hong Kong', region: 'ASIA' },
    { code: 'MO', name: 'Macao', region: 'ASIA' },
    { code: 'MM', name: 'Myanmar', region: 'ASIA' },
    { code: 'LA', name: 'Laos', region: 'ASIA' },
    { code: 'KH', name: 'Cambogia', region: 'ASIA' },
    { code: 'BD', name: 'Bangladesh', region: 'ASIA' },
    { code: 'LK', name: 'Sri Lanka', region: 'ASIA' },
    { code: 'NP', name: 'Nepal', region: 'ASIA' },
    { code: 'BT', name: 'Bhutan', region: 'ASIA' },
    { code: 'MN', name: 'Mongolia', region: 'ASIA' },
    { code: 'KZ', name: 'Kazakistan', region: 'ASIA' },
    { code: 'UZ', name: 'Uzbekistan', region: 'ASIA' },
    { code: 'KG', name: 'Kirghizistan', region: 'ASIA' },
    { code: 'TJ', name: 'Tagikistan', region: 'ASIA' },
    { code: 'TM', name: 'Turkmenistan', region: 'ASIA' },
    { code: 'AF', name: 'Afghanistan', region: 'ASIA' },
    { code: 'PK', name: 'Pakistan', region: 'ASIA' },
    { code: 'IR', name: 'Iran', region: 'ASIA' },
    { code: 'IQ', name: 'Iraq', region: 'ASIA' },
    { code: 'SY', name: 'Siria', region: 'ASIA' },
    { code: 'LB', name: 'Libano', region: 'ASIA' },
    { code: 'JO', name: 'Giordania', region: 'ASIA' },
    { code: 'IL', name: 'Israele', region: 'ASIA' },
    { code: 'PS', name: 'Palestina', region: 'ASIA' },
    { code: 'SA', name: 'Arabia Saudita', region: 'ASIA' },
    { code: 'YE', name: 'Yemen', region: 'ASIA' },
    { code: 'OM', name: 'Oman', region: 'ASIA' },
    { code: 'AE', name: 'Emirati Arabi Uniti', region: 'ASIA' },
    { code: 'QA', name: 'Qatar', region: 'ASIA' },
    { code: 'BH', name: 'Bahrain', region: 'ASIA' },
    { code: 'KW', name: 'Kuwait', region: 'ASIA' },
    
    // Africa
    { code: 'EG', name: 'Egitto', region: 'AFRICA' },
    { code: 'ZA', name: 'Sudafrica', region: 'AFRICA' },
    { code: 'NG', name: 'Nigeria', region: 'AFRICA' },
    { code: 'KE', name: 'Kenya', region: 'AFRICA' },
    { code: 'ET', name: 'Etiopia', region: 'AFRICA' },
    { code: 'TZ', name: 'Tanzania', region: 'AFRICA' },
    { code: 'UG', name: 'Uganda', region: 'AFRICA' },
    { code: 'GH', name: 'Ghana', region: 'AFRICA' },
    { code: 'CI', name: 'Costa d\'Avorio', region: 'AFRICA' },
    { code: 'DZ', name: 'Algeria', region: 'AFRICA' },
    { code: 'MA', name: 'Marocco', region: 'AFRICA' },
    { code: 'TN', name: 'Tunisia', region: 'AFRICA' },
    { code: 'LY', name: 'Libia', region: 'AFRICA' },
    { code: 'SD', name: 'Sudan', region: 'AFRICA' },
    { code: 'SS', name: 'Sud Sudan', region: 'AFRICA' },
    { code: 'CM', name: 'Camerun', region: 'AFRICA' },
    { code: 'CD', name: 'Repubblica Democratica del Congo', region: 'AFRICA' },
    { code: 'CG', name: 'Repubblica del Congo', region: 'AFRICA' },
    { code: 'GA', name: 'Gabon', region: 'AFRICA' },
    { code: 'GQ', name: 'Guinea Equatoriale', region: 'AFRICA' },
    { code: 'ST', name: 'São Tomé e Príncipe', region: 'AFRICA' },
    { code: 'AO', name: 'Angola', region: 'AFRICA' },
    { code: 'ZM', name: 'Zambia', region: 'AFRICA' },
    { code: 'ZW', name: 'Zimbabwe', region: 'AFRICA' },
    { code: 'BW', name: 'Botswana', region: 'AFRICA' },
    { code: 'NA', name: 'Namibia', region: 'AFRICA' },
    { code: 'LS', name: 'Lesotho', region: 'AFRICA' },
    { code: 'SZ', name: 'Eswatini', region: 'AFRICA' },
    { code: 'MG', name: 'Madagascar', region: 'AFRICA' },
    { code: 'MU', name: 'Mauritius', region: 'AFRICA' },
    { code: 'SC', name: 'Seychelles', region: 'AFRICA' },
    { code: 'KM', name: 'Comore', region: 'AFRICA' },
    { code: 'DJ', name: 'Gibuti', region: 'AFRICA' },
    { code: 'SO', name: 'Somalia', region: 'AFRICA' },
    { code: 'ER', name: 'Eritrea', region: 'AFRICA' },
    { code: 'ML', name: 'Mali', region: 'AFRICA' },
    { code: 'BF', name: 'Burkina Faso', region: 'AFRICA' },
    { code: 'NE', name: 'Niger', region: 'AFRICA' },
    { code: 'TD', name: 'Ciad', region: 'AFRICA' },
    { code: 'SN', name: 'Senegal', region: 'AFRICA' },
    { code: 'GM', name: 'Gambia', region: 'AFRICA' },
    { code: 'GW', name: 'Guinea-Bissau', region: 'AFRICA' },
    { code: 'GN', name: 'Guinea', region: 'AFRICA' },
    { code: 'SL', name: 'Sierra Leone', region: 'AFRICA' },
    { code: 'LR', name: 'Liberia', region: 'AFRICA' },
    { code: 'TG', name: 'Togo', region: 'AFRICA' },
    { code: 'BJ', name: 'Benin', region: 'AFRICA' },
    { code: 'CF', name: 'Repubblica Centrafricana', region: 'AFRICA' },
    { code: 'RW', name: 'Ruanda', region: 'AFRICA' },
    { code: 'BI', name: 'Burundi', region: 'AFRICA' },
    { code: 'MZ', name: 'Mozambico', region: 'AFRICA' },
    { code: 'MW', name: 'Malawi', region: 'AFRICA' },
    { code: 'SZ', name: 'Eswatini', region: 'AFRICA' },
    
    // Oceania
    { code: 'AU', name: 'Australia', region: 'OCEANIA' },
    { code: 'NZ', name: 'Nuova Zelanda', region: 'OCEANIA' },
    { code: 'FJ', name: 'Fiji', region: 'OCEANIA' },
    { code: 'PG', name: 'Papua Nuova Guinea', region: 'OCEANIA' },
    { code: 'NC', name: 'Nuova Caledonia', region: 'OCEANIA' },
    { code: 'VU', name: 'Vanuatu', region: 'OCEANIA' },
    { code: 'SB', name: 'Isole Salomone', region: 'OCEANIA' },
    { code: 'TO', name: 'Tonga', region: 'OCEANIA' },
    { code: 'WS', name: 'Samoa', region: 'OCEANIA' },
    { code: 'KI', name: 'Kiribati', region: 'OCEANIA' },
    { code: 'TV', name: 'Tuvalu', region: 'OCEANIA' },
    { code: 'NR', name: 'Nauru', region: 'OCEANIA' },
    { code: 'PW', name: 'Palau', region: 'OCEANIA' },
    { code: 'MH', name: 'Isole Marshall', region: 'OCEANIA' },
    { code: 'FM', name: 'Micronesia', region: 'OCEANIA' }
  ];

  useEffect(() => {
    fetchShippingRates();
  }, []);

  const fetchShippingRates = async () => {
    try {
      setLoading(true);
      const response = await API.get('/shipping');
      // Gestisce sia il caso in cui il backend restituisce {success: true, rates: [...]} 
      // sia il caso in cui restituisce direttamente un array
      let ratesData = [];
      if (response.data.success && response.data.rates) {
        ratesData = response.data.rates;
      } else if (Array.isArray(response.data)) {
        ratesData = response.data;
      }
      
      // Filtra le tariffe valide e aggiungi valori di default per i campi mancanti
      const validRates = ratesData.map(rate => ({
        id: rate.id,
        name: rate.name || 'Tariffa senza nome',
        countries: rate.countries || { apply_to_all: false, specific_countries: [] },
        products: rate.products || { 
          apply_to_all: true, 
          brands: { include: [], exclude: [] }, 
          product_types: { include: [], exclude: [] },
          marketplace_vendors: { include: [], exclude: [] }
        },
        processing_time: rate.processing_time || { min_days: 1, max_days: 2 },
        transit_time: rate.transit_time || { min_days: 1, max_days: 2 },
        shipping_cost: rate.shipping_cost || { type: 'fixed', fixed_amount: 0, price_rules: [], weight_rules: [], item_count_rules: [], free_shipping_threshold: null },
        is_active: rate.is_active !== undefined ? rate.is_active : true,
        created_at: rate.created_at,
        updated_at: rate.updated_at
      }));
      setRates(validRates);
    } catch (error) {
      console.error('Errore nel recupero delle tariffe:', error);
      setMessage('Errore nel recupero delle tariffe di spedizione.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Funzione semplificata per gestire i numeri
  const handleNumberInput = (e, field, isNested = false) => {
    let value = e.target.value;
    
    // Sostituisce la virgola con il punto
    value = value.replace(',', '.');
    
    // Permette solo numeri e punto
    if (!/^[\d.]*$/.test(value) && value !== '') {
      return;
    }
    
    // Mantieni il valore come stringa durante la digitazione
    if (isNested) {
      const path = field.split('.');
      setFormData(prev => {
        const newData = { ...prev };
        let current = newData;
        
        for (let i = 0; i < path.length - 1; i++) {
          current = current[path[i]];
        }
        
        current[path[path.length - 1]] = value;
        return newData;
      });
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  // Funzione semplificata per gestire i numeri nelle regole
  const handleRuleNumberInput = (e, ruleType, index, field, isMaxField = false) => {
    let value = e.target.value;
    value = value.replace(',', '.');
    
    if (!/^[\d.]*$/.test(value) && value !== '') {
      return;
    }
    
    // Mantieni il valore come stringa durante la digitazione
    if (isMaxField) {
      updateRuleAndAdjustNext(ruleType, index, field, value);
    } else {
      updateRule(ruleType, index, field, value);
    }
  };

  // Funzione per gestire i numeri interi (articoli)
  const handleIntegerInput = (e, ruleType, index, field, isMaxField = false) => {
    let value = e.target.value;
    
    if (!/^\d*$/.test(value) && value !== '') {
      return;
    }
    
    // Mantieni il valore come stringa durante la digitazione
    if (isMaxField) {
      updateRuleAndAdjustNext(ruleType, index, field, value);
    } else {
      updateRule(ruleType, index, field, value);
    }
  };

  // Funzione semplificata per i campi numerici del form principale
  const handleFormNumberInput = (e, field) => {
    let value = e.target.value.replace(',', '.');
    if (/^[\d.]*$/.test(value) || value === '') {
      handleNestedChange(field, value);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const handleNestedChange = (path, value) => {
    setFormData(prev => {
      const newData = { ...prev };
      const keys = path.split('.');
      let current = newData;
      
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      
      current[keys[keys.length - 1]] = value;
      return newData;
    });
  };

  const handleArrayChange = (path, value, action = 'add') => {
    setFormData(prev => {
      const newData = { ...prev };
      const keys = path.split('.');
      let current = newData;
      
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      
      if (action === 'add') {
        current[keys[keys.length - 1]] = [...current[keys[keys.length - 1]], value];
      } else if (action === 'remove') {
        current[keys[keys.length - 1]] = current[keys[keys.length - 1]].filter(item => item !== value);
      }
      
      return newData;
    });
  };

  const addRule = (ruleType) => {
    setFormData(prev => {
      const currentRules = prev.shipping_cost[ruleType];
      let newRule;
      
      if (currentRules.length === 0) {
        // Prima regola - usa valori di default
        if (ruleType === 'item_count_rules') {
          newRule = { min_items: 1, max_items: 5, cost: 0 };
        } else if (ruleType === 'weight_rules') {
          newRule = { min_weight: 0, max_weight: 0.5, cost: 0 };
        } else {
          newRule = { min_price: 0, max_price: 50, cost: 0 };
        }
      } else {
        // Regola successiva - parte dal max della precedente
        const lastRule = currentRules[currentRules.length - 1];
        
        if (ruleType === 'item_count_rules') {
          const maxItems = parseFloat(lastRule.max_items) || 0;
          const newMin = maxItems + 1;
          newRule = { min_items: newMin, max_items: newMin + 4, cost: 0 };
        } else if (ruleType === 'weight_rules') {
          const maxWeight = parseFloat(lastRule.max_weight) || 0;
          const newMin = parseFloat((maxWeight + 0.01).toFixed(2));
          newRule = { min_weight: newMin, max_weight: parseFloat((newMin + 1).toFixed(2)), cost: 0 };
        } else {
          // price_rules
          const maxPrice = parseFloat(lastRule.max_price) || 0;
          const newMin = parseFloat((maxPrice + 0.01).toFixed(2));
          newRule = { min_price: newMin, max_price: parseFloat((newMin + 100).toFixed(2)), cost: 0 };
        }
      }
      
      return {
        ...prev,
        shipping_cost: {
          ...prev.shipping_cost,
          [ruleType]: [...currentRules, newRule]
        }
      };
    });
  };

  // Funzione per aggiornare automaticamente i valori min delle regole successive
  const updateRuleAndAdjustNext = (ruleType, index, field, value) => {
    setFormData(prev => {
      const currentRules = [...prev.shipping_cost[ruleType]];
      
      // Aggiorna la regola corrente
      currentRules[index] = { ...currentRules[index], [field]: value };
      
      // Se è stato modificato il valore max, aggiorna il min della regola successiva
      if (field.includes('max_') && index < currentRules.length - 1) {
        const currentRule = currentRules[index];
        const nextRule = currentRules[index + 1];
        
        if (ruleType === 'item_count_rules') {
          const maxItems = parseFloat(currentRule.max_items) || 0;
          const newMin = maxItems + 1;
          currentRules[index + 1] = { ...nextRule, min_items: newMin };
        } else if (ruleType === 'weight_rules') {
          const maxWeight = parseFloat(currentRule.max_weight) || 0;
          const newMin = parseFloat((maxWeight + 0.01).toFixed(2));
          currentRules[index + 1] = { ...nextRule, min_weight: newMin };
        } else if (ruleType === 'price_rules') {
          const maxPrice = parseFloat(currentRule.max_price) || 0;
          const newMin = parseFloat((maxPrice + 0.01).toFixed(2));
          currentRules[index + 1] = { ...nextRule, min_price: newMin };
        }
      }
      
      return {
        ...prev,
        shipping_cost: {
          ...prev.shipping_cost,
          [ruleType]: currentRules
        }
      };
    });
  };

  const removeRule = (ruleType, index) => {
    setFormData(prev => {
      const currentRules = prev.shipping_cost[ruleType].filter((_, i) => i !== index);
      
      // Ricalcola i valori min delle regole rimanenti
      for (let i = 0; i < currentRules.length; i++) {
        if (i === 0) {
          // Prima regola - mantieni il valore min originale
          if (ruleType === 'item_count_rules') {
            currentRules[i].min_items = 1;
          } else if (ruleType === 'weight_rules') {
            currentRules[i].min_weight = 0;
          } else {
            currentRules[i].min_price = 0;
          }
        } else {
          // Regole successive - calcola il min basato sulla regola precedente
          const prevRule = currentRules[i - 1];
          if (ruleType === 'item_count_rules') {
            const maxItems = parseFloat(prevRule.max_items) || 0;
            currentRules[i].min_items = maxItems + 1;
          } else if (ruleType === 'weight_rules') {
            const maxWeight = parseFloat(prevRule.max_weight) || 0;
            currentRules[i].min_weight = parseFloat((maxWeight + 0.01).toFixed(2));
          } else {
            const maxPrice = parseFloat(prevRule.max_price) || 0;
            currentRules[i].min_price = parseFloat((maxPrice + 0.01).toFixed(2));
          }
        }
      }
      
      return {
        ...prev,
        shipping_cost: {
          ...prev.shipping_cost,
          [ruleType]: currentRules
        }
      };
    });
  };

  const updateRule = (ruleType, index, field, value) => {
    setFormData(prev => ({
      ...prev,
      shipping_cost: {
        ...prev.shipping_cost,
        [ruleType]: prev.shipping_cost[ruleType].map((rule, i) => 
          i === index ? { ...rule, [field]: value } : rule
        )
      }
    }));
  };

  const resetForm = () => {
    setFormData({
      name: '',
      countries: {
        apply_to_all: false,
        specific_countries: []
      },
      products: {
        apply_to_all: true,
        brands: {
          include: [],
          exclude: []
        },
        product_types: {
          include: [],
          exclude: []
        },
        marketplace_vendors: {
          include: [],
          exclude: []
        }
      },
      processing_time: {
        min_days: 1,
        max_days: 2
      },
      transit_time: {
        min_days: 1,
        max_days: 2
      },
      shipping_cost: {
        type: 'fixed',
        fixed_amount: 0,
        price_rules: [],
        weight_rules: [],
        item_count_rules: [],
        free_shipping_threshold: null
      }
    });
    setTagInputs({
      brandsInclude: '',
      brandsExclude: '',
      productTypesInclude: '',
      productTypesExclude: '',
      marketplaceVendorsInclude: '',
      marketplaceVendorsExclude: ''
    });
    setCurrentStep(1);
    setShowWizard(false);
  };

  const openWizardForEdit = (rate) => {
    setFormData({
      name: rate.name || '',
      countries: rate.countries || { apply_to_all: false, specific_countries: [] },
      products: rate.products || { 
        apply_to_all: true, 
        brands: { include: [], exclude: [] }, 
        product_types: { include: [], exclude: [] },
        marketplace_vendors: { include: [], exclude: [] }
      },
      processing_time: rate.processing_time || { min_days: 1, max_days: 2 },
      transit_time: rate.transit_time || { min_days: 1, max_days: 2 },
      shipping_cost: rate.shipping_cost || { type: 'fixed', fixed_amount: 0, price_rules: [], weight_rules: [], item_count_rules: [], free_shipping_threshold: null }
    });
    setTagInputs({
      brandsInclude: '',
      brandsExclude: '',
      productTypesInclude: '',
      productTypesExclude: '',
      marketplaceVendorsInclude: '',
      marketplaceVendorsExclude: ''
    });
    setEditMode(true);
    setEditRateId(rate.id);
    setCurrentStep(1);
    setShowWizard(true);
    setWizardMessage('');
  };

  const closeWizard = () => {
    setShowWizard(false);
    setEditMode(false);
    setEditRateId(null);
    resetForm();
    setWizardMessage('');
  };

  const openWizardForNew = () => {
    resetForm();
    setEditMode(false);
    setEditRateId(null);
    setCurrentStep(1);
    setShowWizard(true);
    setWizardMessage('');
  };

  // Funzione per normalizzare i dati prima dell'invio
  const normalizeFormData = (data) => {
    const normalized = { ...data };
    
    // Normalizza i tempi
    if (normalized.processing_time) {
      normalized.processing_time = {
        min_days: parseInt(normalized.processing_time.min_days) || 1,
        max_days: parseInt(normalized.processing_time.max_days) || 2
      };
    }
    if (normalized.transit_time) {
      normalized.transit_time = {
        min_days: parseInt(normalized.transit_time.min_days) || 1,
        max_days: parseInt(normalized.transit_time.max_days) || 2
      };
    }
    
    // Normalizza i costi di spedizione
    if (normalized.shipping_cost) {
      if (normalized.shipping_cost.fixed_amount !== undefined) {
        normalized.shipping_cost.fixed_amount = parseFloat(normalized.shipping_cost.fixed_amount) || 0;
      }
      if (normalized.shipping_cost.free_shipping_threshold !== undefined) {
        normalized.shipping_cost.free_shipping_threshold = 
          normalized.shipping_cost.free_shipping_threshold === '' ? null : 
          parseFloat(normalized.shipping_cost.free_shipping_threshold) || null;
      }
      
      // Normalizza le regole
      if (normalized.shipping_cost.price_rules) {
        normalized.shipping_cost.price_rules = normalized.shipping_cost.price_rules.map(rule => ({
          min_price: parseFloat(rule.min_price) || 0,
          max_price: parseFloat(rule.max_price) || 0,
          cost: parseFloat(rule.cost) || 0
        }));
      }
      if (normalized.shipping_cost.weight_rules) {
        normalized.shipping_cost.weight_rules = normalized.shipping_cost.weight_rules.map(rule => ({
          min_weight: parseFloat(rule.min_weight) || 0,
          max_weight: parseFloat(rule.max_weight) || 0,
          cost: parseFloat(rule.cost) || 0
        }));
      }
      if (normalized.shipping_cost.item_count_rules) {
        normalized.shipping_cost.item_count_rules = normalized.shipping_cost.item_count_rules.map(rule => ({
          min_items: parseInt(rule.min_items) || 0,
          max_items: parseInt(rule.max_items) || 0,
          cost: parseFloat(rule.cost) || 0
        }));
      }
    }
    
    return normalized;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWizardMessage('');
    try {
      const normalizedData = normalizeFormData(formData);
      
      if (editMode && editRateId) {
        const response = await API.put(`/shipping/${editRateId}`, normalizedData);
        // Aggiorna immediatamente lo stato locale
        setRates(prevRates => 
          prevRates.map(rate => 
            rate.id === editRateId ? { ...rate, ...formData } : rate
          )
        );
        // Messaggio di successo nella pagina principale
        setMessage('Tariffa aggiornata con successo!');
        setTimeout(() => setMessage(''), 3000);
        resetForm();
        setEditMode(false);
        setEditRateId(null);
        setShowWizard(false);
      } else {
        const response = await API.post('/shipping', normalizedData);
        // Aggiungi immediatamente la nuova tariffa allo stato locale
        const newRate = response.data || { ...formData, id: Date.now() }; // Fallback se il backend non restituisce dati
        setRates(prevRates => [...prevRates, newRate]);
        // Messaggio di successo nella pagina principale
        setMessage('Tariffa creata con successo!');
        setTimeout(() => setMessage(''), 3000);
        resetForm();
        setEditMode(false);
        setEditRateId(null);
        setShowWizard(false);
      }
    } catch (error) {
      // Messaggio di errore nel popup
      setWizardMessage(error.response?.data?.message || 'Errore durante il salvataggio.');
      // Non chiudere il popup in caso di errore
    }
  };

  const handleDelete = async (rateId) => {
    if (window.confirm('Sei sicuro di voler eliminare questa tariffa?')) {
      try {
        await API.delete(`/shipping/${rateId}`);
        // Aggiorna immediatamente lo stato locale
        setRates(prevRates => prevRates.filter(rate => rate.id !== rateId));
        setMessage('Tariffa eliminata con successo!');
        // Pulisci il messaggio dopo 3 secondi
        setTimeout(() => setMessage(''), 3000);
      } catch (error) {
        setMessage(error.response?.data?.message || 'Errore durante l\'eliminazione.');
        // Pulisci il messaggio di errore dopo 5 secondi
        setTimeout(() => setMessage(''), 5000);
      }
    }
  };

  const nextStep = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  // Funzioni per gestire i tag input
  const handleTagInputChange = (field, value) => {
    setTagInputs(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleTagInputKeyDown = (field, e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      const value = e.target.value.trim();
      if (value) {
        addTag(field, value);
        setTagInputs(prev => ({
          ...prev,
          [field]: ''
        }));
      }
    }
  };

  const addTag = (field, value) => {
    const cleanValue = value.trim();
    if (!cleanValue) return;

    let targetArray;
    switch (field) {
      case 'brandsInclude':
        targetArray = 'products.brands.include';
        break;
      case 'brandsExclude':
        targetArray = 'products.brands.exclude';
        break;
      case 'productTypesInclude':
        targetArray = 'products.product_types.include';
        break;
      case 'productTypesExclude':
        targetArray = 'products.product_types.exclude';
        break;
      case 'marketplaceVendorsInclude':
        targetArray = 'products.marketplace_vendors.include';
        break;
      case 'marketplaceVendorsExclude':
        targetArray = 'products.marketplace_vendors.exclude';
        break;
      default:
        return;
    }

    setFormData(prev => {
      const newData = { ...prev };
      const keys = targetArray.split('.');
      let current = newData;
      
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      
      if (!current[keys[keys.length - 1]].includes(cleanValue)) {
        current[keys[keys.length - 1]] = [...current[keys[keys.length - 1]], cleanValue];
      }
      
      return newData;
    });
  };

  const removeTag = (field, tagToRemove) => {
    let targetArray;
    switch (field) {
      case 'brandsInclude':
        targetArray = 'products.brands.include';
        break;
      case 'brandsExclude':
        targetArray = 'products.brands.exclude';
        break;
      case 'productTypesInclude':
        targetArray = 'products.product_types.include';
        break;
      case 'productTypesExclude':
        targetArray = 'products.product_types.exclude';
        break;
      case 'marketplaceVendorsInclude':
        targetArray = 'products.marketplace_vendors.include';
        break;
      case 'marketplaceVendorsExclude':
        targetArray = 'products.marketplace_vendors.exclude';
        break;
      default:
        return;
    }

    setFormData(prev => {
      const newData = { ...prev };
      const keys = targetArray.split('.');
      let current = newData;
      
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      
      current[keys[keys.length - 1]] = current[keys[keys.length - 1]].filter(tag => tag !== tagToRemove);
      
      return newData;
    });
  };

  const renderTagInput = (field, label, placeholder) => {
    let tags = [];
    switch (field) {
      case 'brandsInclude':
        tags = formData.products.brands.include;
        break;
      case 'brandsExclude':
        tags = formData.products.brands.exclude;
        break;
      case 'productTypesInclude':
        tags = formData.products.product_types.include;
        break;
      case 'productTypesExclude':
        tags = formData.products.product_types.exclude;
        break;
      case 'marketplaceVendorsInclude':
        tags = formData.products.marketplace_vendors.include;
        break;
      case 'marketplaceVendorsExclude':
        tags = formData.products.marketplace_vendors.exclude;
        break;
      default:
        tags = [];
    }

    return (
      <div className="seller-form-group">
        <label className="seller-form-label">{label}:</label>
        <div className="tag-input-container">
          <div className="tags-display">
            {tags.map((tag, index) => (
              <span key={index} className="tag">
                {tag}
                <button
                  type="button"
                  onClick={() => removeTag(field, tag)}
                  className="tag-remove"
                >
                  ×
                </button>
              </span>
            ))}
          </div>
          <input
            type="text"
            value={tagInputs[field]}
            onChange={(e) => handleTagInputChange(field, e.target.value)}
            onKeyDown={(e) => handleTagInputKeyDown(field, e)}
            placeholder={placeholder}
            className="seller-form-control tag-input"
          />
        </div>
      </div>
    );
  };

  const renderStep1 = () => {
    // Funzione per gestire la selezione intelligente delle regioni
    const handleRegionToggle = (regionId, checked) => {
      const regionCountries = countries.filter(c => c.region === regionId);
      
      if (checked) {
        // Seleziona tutti i paesi della regione
        const countryCodes = regionCountries.map(c => c.code);
        setFormData(prev => ({
          ...prev,
          countries: {
            ...prev.countries,
            specific_countries: [...new Set([...prev.countries.specific_countries, ...countryCodes])]
          }
        }));
      } else {
        // Deseleziona tutti i paesi della regione
        const countryCodes = regionCountries.map(c => c.code);
        setFormData(prev => ({
          ...prev,
          countries: {
            ...prev.countries,
            specific_countries: prev.countries.specific_countries.filter(code => !countryCodes.includes(code))
          }
        }));
      }
    };

    // Funzione per gestire la selezione di un singolo paese
    const handleCountryToggle = (countryCode, checked) => {
      setFormData(prev => ({
        ...prev,
        countries: {
          ...prev.countries,
          specific_countries: checked 
            ? [...prev.countries.specific_countries, countryCode]
            : prev.countries.specific_countries.filter(code => code !== countryCode)
        }
      }));
    };

    // Funzione per ottenere lo stato di una regione (completa, parziale, vuota)
    const getRegionState = (regionId) => {
      const regionCountries = countries.filter(c => c.region === regionId);
      const selectedCountries = formData.countries.specific_countries.filter(code => 
        regionCountries.some(c => c.code === code)
      );
      
      if (selectedCountries.length === 0) return 'empty';
      if (selectedCountries.length === regionCountries.length) return 'complete';
      return 'partial';
    };

    return (
      <div className="step-content">
        <h3>Step 1: Informazioni base</h3>
        <p>Inserisci il nome della tariffa e seleziona i paesi di applicazione.</p>
        
        <div className="seller-form-group">
          <label className="seller-form-label">Nome della tariffa *</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            placeholder="Es: Spedizione Standard Europa"
            className="seller-form-control"
            required
          />
        </div>

        <div className="seller-form-group">
          <label className="seller-form-label">
            <input
              type="checkbox"
              checked={formData.countries.apply_to_all}
              onChange={(e) => handleNestedChange('countries.apply_to_all', e.target.checked)}
            />
            Applica a tutto il mondo
          </label>
        </div>

        {!formData.countries.apply_to_all && (
          <div className="seller-form-group">
            <label className="seller-form-label">Seleziona paesi per regione:</label>
            <div className="countries-container">
              {regions.map(region => {
                const regionState = getRegionState(region.id);
                const regionCountries = countries.filter(c => c.region === region.id);
                
                return (
                  <div key={region.id} className="region-group">
                    <div className="region-header">
                      <label className="region-checkbox">
                        <input
                          type="checkbox"
                          checked={regionState === 'complete'}
                          ref={(input) => {
                            if (input) {
                              input.indeterminate = regionState === 'partial';
                            }
                          }}
                          onChange={(e) => handleRegionToggle(region.id, e.target.checked)}
                        />
                        <span className="region-name">{region.name}</span>
                        <span className="region-count">
                          ({regionCountries.filter(c => formData.countries.specific_countries.includes(c.code)).length}/{regionCountries.length})
                        </span>
                      </label>
                    </div>
                    
                    <div className="region-countries">
                      <div className="checkbox-grid">
                        {regionCountries.map(country => (
                          <label key={country.code} className="checkbox-item">
                            <input
                              type="checkbox"
                              checked={formData.countries.specific_countries.includes(country.code)}
                              onChange={(e) => handleCountryToggle(country.code, e.target.checked)}
                            />
                            {country.name}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderStep2 = () => (
    <div className="step-content">
      <h3>Step 2: Prodotti di applicazione</h3>
      <p>Seleziona a quali prodotti si applica questa tariffa.</p>
      
      <div className="seller-form-group">
        <label className="seller-form-label">
          <input
            type="checkbox"
            checked={formData.products.apply_to_all}
            onChange={(e) => handleNestedChange('products.apply_to_all', e.target.checked)}
          />
          Applica a tutti i prodotti
        </label>
      </div>

      {!formData.products.apply_to_all && (
        <>
          {renderTagInput(
            'brandsInclude',
            'Brand inclusi (lascia vuoto per includere tutti)',
            'Inserisci brand e premi Invio o virgola'
          )}

          {renderTagInput(
            'brandsExclude',
            'Brand esclusi',
            'Inserisci brand e premi Invio o virgola'
          )}

          {renderTagInput(
            'productTypesInclude',
            'Tipi di prodotto inclusi (lascia vuoto per includere tutti)',
            'Inserisci tipo prodotto e premi Invio o virgola'
          )}

          {renderTagInput(
            'productTypesExclude',
            'Tipi di prodotto esclusi',
            'Inserisci tipo prodotto e premi Invio o virgola'
          )}

          {renderTagInput(
            'marketplaceVendorsInclude',
            'Marketplace Vendors inclusi (lascia vuoto per includere tutti)',
            'Inserisci vendor e premi Invio o virgola'
          )}

          {renderTagInput(
            'marketplaceVendorsExclude',
            'Marketplace Vendors esclusi',
            'Inserisci vendor e premi Invio o virgola'
          )}
        </>
      )}
    </div>
  );

  const renderStep3 = () => (
    <div className="step-content">
      <h3>Step 3: Tempi di elaborazione e transito</h3>
      <p>Definisci i tempi di elaborazione e spedizione.</p>
      
      <div className="seller-form-group">
        <label className="seller-form-label">Tempo di elaborazione (giorni):</label>
        <div className="range-inputs">
          <input
            type="text"
            value={formData.processing_time.min_days || ''}
            onChange={(e) => handleNumberInput(e, 'processing_time.min_days', true)}
            onKeyPress={handleKeyPress}
            placeholder="Min"
            className="seller-form-control"
          />
          <span>-</span>
          <input
            type="text"
            value={formData.processing_time.max_days || ''}
            onChange={(e) => handleNumberInput(e, 'processing_time.max_days', true)}
            onKeyPress={handleKeyPress}
            placeholder="Max"
            className="seller-form-control"
          />
        </div>
      </div>

      <div className="seller-form-group">
        <label className="seller-form-label">Tempo di transito (giorni):</label>
        <div className="range-inputs">
          <input
            type="text"
            value={formData.transit_time.min_days || ''}
            onChange={(e) => handleNumberInput(e, 'transit_time.min_days', true)}
            onKeyPress={handleKeyPress}
            placeholder="Min"
            className="seller-form-control"
          />
          <span>-</span>
          <input
            type="text"
            value={formData.transit_time.max_days || ''}
            placeholder="Max"
            onChange={(e) => handleNumberInput(e, 'transit_time.max_days', true)}
            onKeyPress={handleKeyPress}
            className="seller-form-control"
          />
        </div>
      </div>
    </div>
  );

  const renderStep4 = () => (
    <div className="step-content">
      <h3>Step 4: Costi di spedizione</h3>
      <p>Definisci come calcolare i costi di spedizione.</p>
      
      {wizardMessage && (
        <div className={`seller-message ${wizardMessage.includes('successo') ? 'success' : 'error'}`}>
          {wizardMessage}
        </div>
      )}
      
      <div className="seller-form-group">
        <label className="seller-form-label">Tipo di tariffa:</label>
        <select
          value={formData.shipping_cost.type}
          onChange={(e) => handleNestedChange('shipping_cost.type', e.target.value)}
          className="seller-form-control"
        >
          <option value="free">Spedizione gratuita</option>
          <option value="fixed">Tariffa fissa</option>
          <option value="price_based">Basata sul prezzo</option>
          <option value="weight_based">Basata sul peso</option>
          <option value="item_count_based">Basata sul numero di articoli</option>
        </select>
      </div>

      {formData.shipping_cost.type === 'fixed' && (
        <div className="seller-form-group">
          <label className="seller-form-label">Importo fisso (€):</label>
          <input
            type="text"
            value={formData.shipping_cost.fixed_amount || ''}
            onChange={(e) => handleFormNumberInput(e, 'shipping_cost.fixed_amount')}
            onKeyPress={handleKeyPress}
            className="seller-form-control"
          />
        </div>
      )}

      {formData.shipping_cost.type === 'price_based' && (
        <div className="seller-form-group">
          <label className="seller-form-label">Regole basate sul prezzo (€):</label>
          {formData.shipping_cost.price_rules.map((rule, index) => (
            <div key={index} className="rule-row">
              <input
                type="text"
                placeholder="Prezzo min (€)"
                value={rule.min_price || ''}
                disabled
                className="seller-form-control disabled-input"
              />
              <span>-</span>
                                            <input
                type="text"
                placeholder="Prezzo max (€)"
                value={rule.max_price || ''}
                onChange={(e) => handleRuleNumberInput(e, 'price_rules', index, 'max_price', true)}
                onKeyPress={handleKeyPress}
                className="seller-form-control"
              />
              <span>Costo (€):</span>
              <input
                type="text"
                placeholder="Costo (€)"
                value={rule.cost || ''}
                onChange={(e) => handleRuleNumberInput(e, 'price_rules', index, 'cost')}
                onKeyPress={handleKeyPress}
                className="seller-form-control"
              />
              <button
                type="button"
                onClick={() => removeRule('price_rules', index)}
                className="seller-btn seller-btn-danger seller-btn-sm"
              >
                Rimuovi
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => addRule('price_rules')}
            className="seller-btn seller-btn-secondary"
          >
            + Aggiungi regola
          </button>
        </div>
      )}

      {formData.shipping_cost.type === 'weight_based' && (
        <div className="seller-form-group">
          <label className="seller-form-label">Regole basate sul peso (kg):</label>
          {formData.shipping_cost.weight_rules.map((rule, index) => (
            <div key={index} className="rule-row">
              <input
                type="text"
                placeholder="Peso min (kg)"
                value={rule.min_weight || ''}
                disabled
                className="seller-form-control disabled-input"
              />
              <span>-</span>
                                            <input
                type="text"
                placeholder="Peso max (kg)"
                value={rule.max_weight || ''}
                onChange={(e) => handleRuleNumberInput(e, 'weight_rules', index, 'max_weight', true)}
                onKeyPress={handleKeyPress}
                className="seller-form-control"
              />
              <span>Costo (€):</span>
              <input
                type="text"
                placeholder="Costo (€)"
                value={rule.cost || ''}
                onChange={(e) => handleRuleNumberInput(e, 'weight_rules', index, 'cost')}
                onKeyPress={handleKeyPress}
                className="seller-form-control"
              />
              <button
                type="button"
                onClick={() => removeRule('weight_rules', index)}
                className="seller-btn seller-btn-danger seller-btn-sm"
              >
                Rimuovi
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => addRule('weight_rules')}
            className="seller-btn seller-btn-secondary"
          >
            + Aggiungi regola
          </button>
        </div>
      )}

      {formData.shipping_cost.type === 'item_count_based' && (
        <div className="seller-form-group">
          <label className="seller-form-label">Regole basate sul numero di articoli (unità):</label>
          {formData.shipping_cost.item_count_rules.map((rule, index) => (
            <div key={index} className="rule-row">
              <input
                type="text"
                placeholder="Articoli min (unità)"
                value={rule.min_items || ''}
                disabled
                className="seller-form-control disabled-input"
              />
              <span>-</span>
                                            <input
                type="text"
                placeholder="Articoli max (unità)"
                value={rule.max_items || ''}
                onChange={(e) => handleIntegerInput(e, 'item_count_rules', index, 'max_items', true)}
                onKeyPress={handleKeyPress}
                className="seller-form-control"
              />
              <span>Costo (€):</span>
              <input
                type="text"
                placeholder="Costo (€)"
                value={rule.cost || ''}
                onChange={(e) => handleRuleNumberInput(e, 'item_count_rules', index, 'cost')}
                onKeyPress={handleKeyPress}
                className="seller-form-control"
              />
              <button
                type="button"
                onClick={() => removeRule('item_count_rules', index)}
                className="seller-btn seller-btn-danger seller-btn-sm"
              >
                Rimuovi
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={() => addRule('item_count_rules')}
            className="seller-btn seller-btn-secondary"
          >
            + Aggiungi regola
          </button>
        </div>
      )}

      {(formData.shipping_cost.type === 'fixed' || formData.shipping_cost.type === 'price_based' || formData.shipping_cost.type === 'weight_based' || formData.shipping_cost.type === 'item_count_based') && (
        <div className="seller-form-group">
          <label className="seller-form-label">Soglia per spedizione gratuita (€) - opzionale:</label>
          <input
            type="text"
            value={formData.shipping_cost.free_shipping_threshold || ''}
            onChange={(e) => {
              let value = e.target.value.replace(',', '.');
              if (/^[\d.]*$/.test(value) || value === '') {
                handleNestedChange('shipping_cost.free_shipping_threshold', value);
              }
            }}
            onKeyPress={handleKeyPress}
            placeholder="Lascia vuoto per disabilitare"
            className="seller-form-control"
          />
        </div>
      )}
    </div>
  );

  const renderWizard = () => (
    <div className="wizard-overlay">
      <div className="wizard-modal">
        <div className="wizard-header">
          <h2>{editMode ? 'Modifica Tariffa' : 'Nuova Tariffa di Spedizione'}</h2>
          <button onClick={closeWizard} className="seller-btn seller-btn-secondary seller-btn-sm">&times;</button>
        </div>

        <div className="progress-bar">
          <div className="progress-steps">
            <div className={`step ${currentStep > 1 ? 'completed' : currentStep === 1 ? 'active' : ''}`}>
              <span className="step-number">1</span>
              <span className="step-label">Paesi</span>
            </div>
            <div className={`step ${currentStep > 2 ? 'completed' : currentStep === 2 ? 'active' : ''}`}>
              <span className="step-number">2</span>
              <span className="step-label">Prodotti</span>
            </div>
            <div className={`step ${currentStep > 3 ? 'completed' : currentStep === 3 ? 'active' : ''}`}>
              <span className="step-number">3</span>
              <span className="step-label">Tempi</span>
            </div>
            <div className={`step ${currentStep === 4 ? 'active' : ''}`}>
              <span className="step-number">4</span>
              <span className="step-label">Costi</span>
            </div>
          </div>
          <div className="progress-line">
            <div 
              className="progress-fill" 
              style={{ width: `${(currentStep - 1) * 33.33}%` }}
            ></div>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {currentStep === 1 && renderStep1()}
          {currentStep === 2 && renderStep2()}
          {currentStep === 3 && renderStep3()}
          {currentStep === 4 && renderStep4()}

          <div className="wizard-actions">
            {currentStep > 1 && (
              <button type="button" onClick={prevStep} className="seller-btn seller-btn-secondary">
                ← Indietro
              </button>
            )}
            {currentStep < 4 ? (
              <button type="button" onClick={nextStep} className="seller-btn seller-btn-primary">
                Avanti →
              </button>
            ) : (
              <button type="submit" className="seller-btn seller-btn-primary">
                {editMode ? 'Salva Modifiche' : 'Salva Tariffa'}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );

  if (loading) {
    return <SellerSpinner text="Caricamento tariffe..." />;
  }

  return (
    <>
      <div className="seller-page-header">
        <h1>Tariffe di spedizione</h1>
        <p>Gestisci le tariffe di spedizione per i tuoi prodotti</p>
      </div>

      {message && (
        <div className={`seller-message ${message.includes('successo') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      <div className="seller-shipping-actions">
        <button onClick={openWizardForNew} className="seller-btn seller-btn-primary">
          <span>+</span>
          Nuova Tariffa
        </button>
      </div>

      <div className="rates-list">
        {rates.length === 0 ? (
          <div className="empty-state">
            <p>Non hai ancora creato nessuna tariffa di spedizione.</p>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.875rem', marginBottom: '1.5rem' }}>
              Crea la tua prima tariffa per iniziare a gestire le spedizioni
            </p>
            <button onClick={openWizardForNew} className="seller-btn seller-btn-primary">
              <span>+</span>
              Crea la tua prima tariffa
            </button>
          </div>
        ) : (
          rates.map(rate => (
            <div key={rate.id} className="rate-card">
              <div className="rate-header">
                <h3>{rate.name || 'Tariffa senza nome'}</h3>
                <div className="rate-actions">
                  <span className={`status ${rate.is_active !== false ? 'active' : 'inactive'}`}>
                    {rate.is_active !== false ? 'Attiva' : 'Inattiva'}
                  </span>
                  <button
                    onClick={() => openWizardForEdit(rate)}
                    className="seller-btn seller-btn-secondary seller-btn-sm"
                    title="Modifica tariffa"
                  >
                    Modifica
                  </button>
                  <button
                    onClick={() => handleDelete(rate.id)}
                    className="seller-btn seller-btn-danger seller-btn-sm"
                    title="Elimina tariffa"
                  >
                    Elimina
                  </button>
                </div>
              </div>
              
              <div className="rate-details">
                <div className="detail-group">
                  <strong>Paesi:</strong>
                  {rate.countries?.apply_to_all ? (
                    <span>Tutto il mondo</span>
                  ) : (
                    <span>
                      {rate.countries?.specific_countries?.length > 0 ? (
                        <span>
                          {rate.countries.specific_countries.length} paese{rate.countries.specific_countries.length !== 1 ? 'i' : ''} selezionato{rate.countries.specific_countries.length !== 1 ? 'i' : ''}
                          {rate.countries.specific_countries.length <= 5 && (
                            <span>: {rate.countries.specific_countries.join(', ')}</span>
                          )}
                        </span>
                      ) : (
                        <span>Nessun paese selezionato</span>
                      )}
                    </span>
                  )}
                </div>
                
                <div className="detail-group">
                  <strong>Prodotti:</strong>
                  {rate.products?.apply_to_all ? (
                    <span>Tutti i prodotti</span>
                  ) : (
                    <span>
                      Selezionati
                      {rate.products?.brands?.include?.length > 0 && (
                        <div style={{ fontSize: '0.8em', color: '#666', marginTop: '2px' }}>
                          Brand: {rate.products.brands.include.join(', ')}
                        </div>
                      )}
                      {rate.products?.product_types?.include?.length > 0 && (
                        <div style={{ fontSize: '0.8em', color: '#666', marginTop: '2px' }}>
                          Tipi: {rate.products.product_types.include.join(', ')}
                        </div>
                      )}
                      {rate.products?.marketplace_vendors?.include?.length > 0 && (
                        <div style={{ fontSize: '0.8em', color: '#666', marginTop: '2px' }}>
                          Marketplace: {rate.products.marketplace_vendors.include.join(', ')}
                        </div>
                      )}
                    </span>
                  )}
                </div>
                
                <div className="detail-group">
                  <strong>Tempi:</strong>
                  <span>
                    Elaborazione: {rate.processing_time?.min_days || 1}-{rate.processing_time?.max_days || 2} giorni<br/>
                    Transito: {rate.transit_time?.min_days || 1}-{rate.transit_time?.max_days || 2} giorni
                  </span>
                </div>
                
                <div className="detail-group">
                  <strong>Costo:</strong>
                  <span>
                    {rate.shipping_cost?.type === 'free' && 'Spedizione gratuita'}
                    {rate.shipping_cost?.type === 'fixed' && `€${rate.shipping_cost?.fixed_amount || 0}`}
                    {rate.shipping_cost?.type === 'price_based' && 'Basato sul prezzo'}
                    {rate.shipping_cost?.type === 'weight_based' && 'Basato sul peso'}
                    {rate.shipping_cost?.type === 'item_count_based' && 'Basato sul numero di articoli'}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {showWizard && renderWizard()}
    </>
  );
};

export default ShippingRatesPage; 